import React from 'react'
import PT from 'prop-types'
import R from 'ramda'
import RadioButtonGroup from '@vimcar/shared-components/components/RadioButtonGroup'
import linkStore from '@vimcar/shared-utils/linkStore'

import i18n from '#utils/i18n'
import mkStore from './store'
import styles from './styles.css'

const tp = i18n.prefix('components.ProfilePreferences')

const DefaultViewPreferences = ({
  className,
  store,
  titleClassName,
}) => (
  <section className={className}>
    <h3 className={titleClassName}>{tp('default-view')}</h3>
    <RadioButtonGroup
      className={styles.radioGroup}
      name={store.preferencesKey}
      onChange={(_, value) => store.handleChange(value)}
      valueSelected={store.defaultView}
      >
      {R.map(ViewOption, store.availableViews)}
    </RadioButtonGroup>
  </section>
)

const ViewOption = ({ view, label, checked, disabled }) => (
  <RadioButtonGroup.RadioButton
    checked={checked}
    disabled={disabled}
    key={view}
    label={label}
    value={view}
    />
)

ViewOption.propTypes = {
  checked: PT.bool,
  disabled: PT.bool,
  label: PT.string.isRequired,
  view: PT.string.isRequired,
}

DefaultViewPreferences.propTypes = {
  className: PT.string,
  store: PT.shape({
    availableViews: PT.arrayOf(PT.shape({
      checked: PT.bool,
      disabled: PT.bool,
      label: PT.string.isRequired,
      view: PT.string.isRequired,
    })).isRequired,
    defaultView: PT.string,
    handleChange: PT.func.isRequired,
    preferencesKey: PT.string,
  }),
  titleClassName: PT.string,
}

export default linkStore(mkStore, DefaultViewPreferences)
